import { useQuery, useInfiniteQuery, queryOptions, infiniteQueryOptions } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { listDeals, getDeal, listDealTrash, listStageSummaries } from '../../api/crmApi';

import { dealsKeys } from './keys';

export const dealsListOptions = (filters = {}) =>
	queryOptions({
		queryKey: dealsKeys.list(filters),
		queryFn: async () => listDeals(filters),
		staleTime: STALE_TIMES.FREQUENT,
	});

export function useDealsList(filters = {}, { enabled = true } = {}) {
	return useQuery({ ...dealsListOptions(filters), enabled });
}

const STAGE_DEALS_PAGE_SIZE = 20;

export function useStageSummaries(pipelineId, filters = {}) {
	return useQuery({
		queryKey: dealsKeys.stageSummaries(pipelineId, filters),
		queryFn: () => listStageSummaries({ pipelineId, ...filters }),
		staleTime: STALE_TIMES.FREQUENT,
		enabled: Boolean(pipelineId),
	});
}

export const stageDealsInfiniteOptions = (pipelineId, stageId, filters = {}) =>
	infiniteQueryOptions({
		queryKey: dealsKeys.byStageInfinite(pipelineId, stageId, filters),
		queryFn: async ({ pageParam = 1 }) => {
			return listDeals({
				pipelineId,
				stageId,
				page: pageParam,
				pageSize: STAGE_DEALS_PAGE_SIZE,
				orderBy: 'nextActivityDueAt',
				orderDir: 'asc',
				...filters,
			});
		},
		initialPageParam: 1,
		getNextPageParam: (lastPage) =>
			lastPage.currentPage < lastPage.totalPageCount ? lastPage.currentPage + 1 : undefined,
		staleTime: STALE_TIMES.FREQUENT,
	});

export function useStageDealsInfinite(pipelineId, stageId, filters = {}) {
	return useInfiniteQuery({
		...stageDealsInfiniteOptions(pipelineId, stageId, filters),
		enabled: Boolean(pipelineId) && Boolean(stageId),
	});
}

export const dealDetailOptions = (dealId) =>
	queryOptions({
		queryKey: dealsKeys.detail(dealId),
		queryFn: async () => getDeal(dealId),
		staleTime: STALE_TIMES.FREQUENT,
	});

export function useDealDetail(dealId) {
	return useQuery({
		...dealDetailOptions(dealId),
		enabled: Boolean(dealId),
	});
}

export function useDealTrash(filters = {}, { enabled = true } = {}) {
	return useQuery({
		queryKey: dealsKeys.trash(filters),
		queryFn: async () => listDealTrash(filters),
		staleTime: STALE_TIMES.FREQUENT,
		enabled,
	});
}
